"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlEntities = htmlEntities;
var _escape2 = _interopRequireDefault(require("lodash/escape"));
/**
 * Encode characters to html entities
 *
 * @param string string
 *
 * @return string encoded string
 */
function htmlEntities(string) {
  return (0, _escape2.default)(string);
}